import React, { createContext, useCallback, useEffect, useReducer } from 'react';
import { authenticationService } from "../authentication-service.js";
import { addOidcEvents, logout, login as oidcLogin, oidcReducer, removeOidcEvents } from "../oidc-events.js";
import { CallbackContainer } from "./callback.js";
import { OidcRoutes } from "./oidc-routes.js";
import { SessionLostContainer } from "./session-lost.js";
export const AuthenticationContext = /*#__PURE__*/createContext(undefined);
const setDefaultState = configuration => ({
  userManager: authenticationService(configuration),
  isLoading: false
});
export const AuthenticationProvider = props => {
  const [oidcState, dispatch] = useReducer(oidcReducer, setDefaultState(props.configuration));
  useEffect(() => {
    dispatch({
      type: 'ON_LOADING'
    });
    addOidcEvents({
      customEvents: props.customEvents,
      dispatch,
      userManager: oidcState.userManager
    });
    oidcState.userManager.getUser().then(user => {
      if (!user) {
        return;
      }
      dispatch({
        type: 'ON_LOAD_USER',
        user
      });
    });
    return () => removeOidcEvents({
      customEvents: props.customEvents,
      dispatch,
      userManager: oidcState.userManager
    });
  }, [oidcState.userManager, props.customEvents]);
  const {
    oidcUser,
    isLoading,
    error
  } = oidcState;
  const {
    authenticating,
    notAuthenticated,
    notAuthorized,
    callbackComponentOverride,
    sessionLost,
    configuration,
    children,
    history
  } = props;
  const login = useCallback(async () => await oidcLogin(oidcState.userManager, dispatch, history.location, history)(), [history, oidcState.userManager]);
  return /*#__PURE__*/React.createElement(AuthenticationContext.Provider, {
    value: {
      isLoading,
      oidcUser,
      error,
      authenticating: authenticating === null || authenticating === void 0 ? void 0 : authenticating(),
      login,
      logout: useCallback(() => logout(oidcState.userManager, dispatch)(), [oidcState.userManager])
    }
  }, /*#__PURE__*/React.createElement(OidcRoutes, {
    notAuthenticated: notAuthenticated === null || notAuthenticated === void 0 ? void 0 : notAuthenticated({
      login
    }),
    notAuthorized: notAuthorized === null || notAuthorized === void 0 ? void 0 : notAuthorized(),
    callbackComponent: /*#__PURE__*/React.createElement(CallbackContainer, {
      callbackComponentOverride: callbackComponentOverride === null || callbackComponentOverride === void 0 ? void 0 : callbackComponentOverride(),
      history: history
    }),
    sessionLost: /*#__PURE__*/React.createElement(SessionLostContainer, {
      SessionLostComponentOverride: sessionLost,
      history: history
    }),
    configuration: configuration
  }, children));
};
//# sourceMappingURL=authentication-provider.js.map